import { Tag as BaseTag, Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';

const Tag = styled(BaseTag)`
  font-size: 13px;
  margin: 0;
  padding: 3px 9px;
  width: fit-content;
`;

export const TRUNCATED_TAG_DEFAULT_MAX_LENGTH = 20;

export interface TruncatedTagProps {
  disabled?: boolean;
  label: string;
  maxLength?: number;
  onRemove: () => void;
}

function TruncatedTag({
  disabled,
  label,
  maxLength = TRUNCATED_TAG_DEFAULT_MAX_LENGTH,
  onRemove,
}: TruncatedTagProps) {
  const isTruncated = label.length > maxLength;
  const labelText = isTruncated ? `${label.slice(0, maxLength)}...` : label;

  const tagEl = (
    <Tag closable={!disabled} onClose={onRemove}>
      {labelText}
    </Tag>
  );

  return isTruncated ? <Tooltip title={label}>{tagEl}</Tooltip> : tagEl;
}

export default TruncatedTag;
